import { Theme, ThemeName } from '@/types/theme';
import logo from '@/images/brandtv_logo.svg?react';
import BrandTVBackdrop from './brandtv/brandtv-backdrop/brandtv-backdrop';

const brandTV: Theme = {
  name: ThemeName.BRANDTV,
  backdrop: {
    component: BrandTVBackdrop,
  },
  logo: logo,
};

export default brandTV;
